export default __webpack_public_path__ + "static/media/other.41dfa62f.webp";